/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_Editor_Add_LanguageInputs */

const en_resume_editor_add_language = /** @type {(inputs: Resume_Editor_Add_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Add Language`)
};

const de_resume_editor_add_language = /** @type {(inputs: Resume_Editor_Add_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Sprache hinzufuegen`)
};

const fr_resume_editor_add_language = /** @type {(inputs: Resume_Editor_Add_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Ajouter une langue`)
};

const es_resume_editor_add_language = /** @type {(inputs: Resume_Editor_Add_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Anadir idioma`)
};

const it_resume_editor_add_language = /** @type {(inputs: Resume_Editor_Add_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Aggiungi lingua`)
};

const nl_resume_editor_add_language = /** @type {(inputs: Resume_Editor_Add_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Taal toevoegen`)
};

const pl_resume_editor_add_language = /** @type {(inputs: Resume_Editor_Add_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Dodaj jezyk`)
};

const fi_resume_editor_add_language = /** @type {(inputs: Resume_Editor_Add_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Lisää kieli`)
};

const da_resume_editor_add_language = /** @type {(inputs: Resume_Editor_Add_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Tilföj sprog`)
};

const sv_resume_editor_add_language = /** @type {(inputs: Resume_Editor_Add_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Lagg till sprak`)
};

/**
* | output |
* | --- |
* | "+ Add Language" |
*
* @param {Resume_Editor_Add_LanguageInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resume_editor_add_language = /** @type {((inputs?: Resume_Editor_Add_LanguageInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_Editor_Add_LanguageInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resume_editor_add_language(inputs)
	if (locale === "fr") return fr_resume_editor_add_language(inputs)
	if (locale === "es") return es_resume_editor_add_language(inputs)
	if (locale === "it") return it_resume_editor_add_language(inputs)
	if (locale === "nl") return nl_resume_editor_add_language(inputs)
	if (locale === "pl") return pl_resume_editor_add_language(inputs)
	if (locale === "fi") return fi_resume_editor_add_language(inputs)
	if (locale === "da") return da_resume_editor_add_language(inputs)
	if (locale === "sv") return sv_resume_editor_add_language(inputs)
	return en_resume_editor_add_language(inputs)
});